module.exports = __webpack_public_path__ + "img/spire-logo.6ccef353.jpg";